$shm_hitalama_vk_posts_multi $mol_ghost
	owner_ids /string
	Posts_by_owner* $shm_hitalama_vk_posts
		token_str <= token_str \
		owner_id? <=> owner_id*? \
		collect? => collect*?
		dto => dto_by_owner*
		pending => posts_pending*
	post_id* \
	post_date* \
	post_likes* \
	post_reposts* \
	post_comments* \
	post_views* \
